/**
 * Rhode Product Page — Shopify Section JS
 */
(function () {
  'use strict';

  /* ---- Gallery ---- */
  function initGallery() {
    var main = document.querySelector('.rh-gallery-main');
    if (!main) return;
    var slides = main.querySelectorAll('.rh-gslide');
    var thumbs = document.querySelectorAll('.rh-gthumbs button:not(.rh-gthumbs__arrow)');
    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () {
        slides.forEach(function (s) { s.classList.remove('active'); });
        thumbs.forEach(function (b) { b.classList.remove('active'); });
        if (slides[idx]) slides[idx].classList.add('active');
        t.classList.add('active');
      });
    });

    // Flèche de scroll pour thumbs verticaux flottants
    var thumbsList = document.querySelector('[data-rh-thumbs-list]');
    var thumbsArrow = document.querySelector('[data-rh-thumbs-arrow]');
    if (thumbsList && thumbsArrow) {
      var step = 60;
      function updateArrow() {
        var atEnd = thumbsList.scrollTop + thumbsList.clientHeight >= thumbsList.scrollHeight - 2;
        thumbsArrow.classList.toggle('is-end', atEnd);
      }
      thumbsArrow.addEventListener('click', function () {
        var atEnd = thumbsList.scrollTop + thumbsList.clientHeight >= thumbsList.scrollHeight - 2;
        if (atEnd) {
          thumbsList.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          thumbsList.scrollBy({ top: step, behavior: 'smooth' });
        }
        setTimeout(updateArrow, 300);
      });
      thumbsList.addEventListener('scroll', updateArrow);
      updateArrow();
    }
  }

  /* ---- Variant / shade selector ---- */
  function initShades() {
    var swatches = document.querySelectorAll('.rh-swatch');
    var nameEl = document.querySelector('.rh-shades__current');
    if (!swatches.length) return;

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('active'); });
        sw.classList.add('active');
        if (nameEl) nameEl.textContent = sw.getAttribute('data-name');

        // Mise à jour du select variant Shopify caché
        var variantId = sw.getAttribute('data-variant');
        var select = document.querySelector('.rh-variant-select');
        if (select && variantId) {
          select.value = variantId;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Met à jour l'URL sans recharger
        var url = sw.getAttribute('data-url');
        if (url && window.history.replaceState) {
          window.history.replaceState({}, '', url);
        }

        // Change l'image principale si le swatch a une image liée
        var imgSrc = sw.getAttribute('data-image');
        if (imgSrc) {
          var slides = document.querySelectorAll('.rh-gslide');
          if (slides.length) {
            slides.forEach(function (s) { s.classList.remove('active'); });
            slides[0].classList.add('active');
            var img = slides[0].querySelector('img');
            if (img) img.src = imgSrc;
          }
        }
      });
    });
  }

  /* ---- Helpers ---- */
  function formatMoney(cents) {
    try {
      var fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
      return fmt.format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }
  function updateAtcLabel(price, variantTitle, available) {
    var btn = document.querySelector('[data-rh-atc]');
    if (!btn) return;
    var label = btn.querySelector('[data-rh-atc-label]');
    if (!label) return;
    if (!available) {
      label.textContent = btn.getAttribute('data-rh-soldout') || 'sold out';
      btn.disabled = true;
      return;
    }
    btn.disabled = false;
    var tpl = btn.getAttribute('data-rh-atc-tpl') || 'add to bag — {price}';
    label.textContent = tpl
      .replace('{price}', formatMoney(price))
      .replace('{variant}', variantTitle || '');
  }

  /* ---- Variant groups (dropdown Style + swatches Solo/Duo) ---- */
  function initVariantGroups() {
    var swatches = document.querySelectorAll('[data-rh-vg-swatch]');
    var select = document.querySelector('[data-rh-vg-select]');
    var hiddenVariant = document.querySelector('.rh-variant-select');

    function selectVariant(id, opts) {
      opts = opts || {};
      var target = null;
      swatches.forEach(function (s) {
        var active = s.getAttribute('data-variant-id') === String(id);
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) target = s;
      });
      if (select) select.value = id;
      if (hiddenVariant) {
        hiddenVariant.value = id;
        hiddenVariant.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (target) {
        var price = parseInt(target.getAttribute('data-variant-price'), 10) || 0;
        var title = target.getAttribute('data-variant-title') || '';
        var available = target.getAttribute('data-variant-available') === 'true';
        updateAtcLabel(price, title, available);
        var url = target.getAttribute('data-variant-url');
        if (url && window.history.replaceState) { window.history.replaceState({}, '', url); }
        var imgSrc = target.getAttribute('data-variant-image');
        if (imgSrc && !opts.skipImage) {
          var slides = document.querySelectorAll('.rh-gslide');
          if (slides.length) {
            slides.forEach(function (s) { s.classList.remove('active'); });
            slides[0].classList.add('active');
            var img = slides[0].querySelector('img');
            if (img) img.src = imgSrc;
          }
        }
      }
    }

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        if (sw.disabled) return;
        selectVariant(sw.getAttribute('data-variant-id'));
      });
    });
    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var href = opt && opt.getAttribute('data-href');
        if (href) { window.location.href = href; return; }
        selectVariant(select.value);
      });
    }
  }

  /* ---- Accordion ---- */
  function initAccordion() {
    document.querySelectorAll('.rh-acc-item').forEach(function (item) {
      var btn = item.querySelector('.rh-acc-btn');
      var body = item.querySelector('.rh-acc-body');
      if (!btn || !body) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        // Ferme tous
        document.querySelectorAll('.rh-acc-item').forEach(function (i) {
          i.classList.remove('open');
          var b = i.querySelector('.rh-acc-body');
          if (b) b.style.maxHeight = null;
          var trigger = i.querySelector('.rh-acc-btn');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });
        // Ouvre si fermé
        if (!isOpen) {
          item.classList.add('open');
          body.style.maxHeight = body.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---- Review keywords toggle ---- */
  function initKeywords() {
    document.querySelectorAll('.rh-rev-kw').forEach(function (k) {
      k.addEventListener('click', function () { k.classList.toggle('active'); });
    });
  }

  /* ---- Scroll reveal ---- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.rh-reveal').forEach(function (el) { el.classList.add('rh-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rh-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.rh-reveal').forEach(function (el) { obs.observe(el); });
  }

  /* ---- Add to cart AJAX ---- */
  function initATC() {
    var form = document.querySelector('.rh-product-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.rh-atc');
      var label = btn ? btn.querySelector('[data-rh-atc-label]') : null;
      var target = label || btn;
      if (!target) return;
      var originalText = target.textContent;
      btn.disabled = true;
      target.textContent = 'adding...';

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          target.textContent = 'added ✓';
          setTimeout(function () {
            target.textContent = originalText;
            btn.disabled = false;
          }, 1500);
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var counters = document.querySelectorAll('[data-cart-count]');
            counters.forEach(function (c) { c.textContent = cart.item_count; });
          });
        })
        .catch(function () {
          target.textContent = 'error — try again';
          btn.disabled = false;
        });
    });
  }

  /* ---- Get the set tabs + variant selectors ---- */
  function initGts() {
    var tabs = document.querySelectorAll('[data-rh-gts-tab]');
    var panels = document.querySelectorAll('[data-rh-gts-panel]');
    if (tabs.length) {
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var key = t.getAttribute('data-rh-gts-tab');
          tabs.forEach(function (tt) {
            var on = tt === t;
            tt.classList.toggle('is-active', on);
            tt.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-rh-gts-panel') === key);
          });
        });
      });
    }

    document.querySelectorAll('[data-rh-gts-card]').forEach(function (card) {
      var sel = card.querySelector('[data-rh-gts-variant]');
      if (!sel) return;
      var btn = card.querySelector('[data-rh-gts-btn]');
      var priceEl = card.querySelector('[data-rh-gts-price]');
      var imgEl = card.querySelector('[data-rh-gts-img]');
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        if (priceEl) priceEl.textContent = opt.getAttribute('data-price') || priceEl.textContent;
        if (btn) {
          var url = opt.getAttribute('data-url');
          if (url) btn.setAttribute('href', url);
        }
        if (imgEl) {
          var img = opt.getAttribute('data-image');
          if (img) imgEl.setAttribute('src', img);
        }
      });
    });
  }

  /* ---- Init ---- */
  function init() {
    initGallery();
    initShades();
    initVariantGroups();
    initAccordion();
    initKeywords();
    initReveal();
    initATC();
    initGts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
